import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';

import { ClaimLinesPartialState } from './claim-lines.reducer';
import {
  LoadClaimLines,
  LoadClaimLinesSuccess,
  LoadClaimLinesFail,
  ClaimLinesActionTypes,
  ListClaimLinesByStatus,
  ListClaimLinesByStatusSuccess,
  ListClaimLinesByStatusFail,
  ListClaimLinesByAssignee,
  ListClaimLinesByAssigneeSuccess,
  ListClaimLinesByAssigneeFail,
  ListClaimLinesByCurrentUser,
  ListClaimLinesByCurrentUserSuccess,
  ListClaimLinesByCurrentUserFail,
  CreateClaimLine,
  CreateClaimLineSuccess,
  CreateClaimLineFail,
  EditClaimLine,
  EditClaimLineSuccess,
  EditClaimLineFail,
  DeleteClaimLine,
  DeleteClaimLineSuccess,
  DeleteClaimLineFail,
  AssignClaimLine,
  AssignClaimLineSuccess,
  AssignClaimLineFail,
  VerifyClaimLine,
  VerifyClaimLineSuccess,
  VerifyClaimLineFail,
  ApproveClaimLine,
  ApproveClaimLineSuccess,
  ApproveClaimLineFail,
  ReturnClaimLine,
  ReturnClaimLineSuccess,
  ReturnClaimLineFail,
  SubmitClaimLine,
  SubmitClaimLineSuccess,
  SubmitClaimLineFail,
  RejectClaimLine,
  RejectClaimLineSuccess,
  RejectClaimLineFail
} from './claim-lines.actions';
import { ClaimLinesService } from '../claim-lines.service';
import { map } from 'rxjs/operators';
import { Pagination } from '@ecosure-suite/shared/utils-helpers';
import {
  ClaimLine,
  ClaimRequest,
  ClaimLineForm
} from '@ecosure-suite/shared/util-entities';

@Injectable({
  providedIn: 'root'
})
export class ClaimLinesEffects {
  @Effect() listByStatus$ = this.dataPersistence.fetch(
    ClaimLinesActionTypes.LIST_CLAIM_LINE_BY_STATUS,
    {
      run: (action: ListClaimLinesByStatus, state: ClaimLinesPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .listByStatusOrAssignee(action.payload)
          .pipe(
            map(
              (claimLines: {
                claimLines: (ClaimLine & { claimRequest: ClaimRequest })[];
                page: Pagination;
              }) => new ListClaimLinesByStatusSuccess(claimLines)
            )
          );
      },

      onError: (action: ListClaimLinesByStatus, error) => {
        
        return new ListClaimLinesByStatusFail(error);
      }
    }
  );

  @Effect() listByAssignee$ = this.dataPersistence.fetch(
    ClaimLinesActionTypes.LIST_CLAIM_LINE_BY_ASSIGNEE,
    {
      run: (
        action: ListClaimLinesByAssignee,
        state: ClaimLinesPartialState
      ) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .listByStatusOrAssignee(action.payload)
          .pipe(
            map(
              (claimLines: {
                claimLines: (ClaimLine & { claimRequest: ClaimRequest })[];
                page: Pagination;
              }) => new ListClaimLinesByAssigneeSuccess(claimLines)
            )
          );
      },

      onError: (action: ListClaimLinesByAssignee, error) => {
        
        return new ListClaimLinesByAssigneeFail(error);
      }
    }
  );

  @Effect() listByCurrentUser$ = this.dataPersistence.fetch(
    ClaimLinesActionTypes.LIST_CLAIM_LINE_BY_CURRENT_USER,
    {
      run: (
        action: ListClaimLinesByCurrentUser,
        state: ClaimLinesPartialState
      ) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .getClaimLinesByCurrentUser(action.payload)
          .pipe(
            map(
              (claimLines: { claimLines: ClaimLine[]; page: Pagination }) =>
                new ListClaimLinesByCurrentUserSuccess(claimLines)
            )
          );
      },

      onError: (action: ListClaimLinesByCurrentUser, error) => {
        
        return new ListClaimLinesByCurrentUserFail(error);
      }
    }
  );

  @Effect() getByClaimId$ = this.dataPersistence.fetch(
    ClaimLinesActionTypes.LOAD_CLAIM_LINE,
    {
      run: (action: LoadClaimLines, state: ClaimLinesPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .get(action.payload)
          .pipe(
            map(
              (claimLines: ClaimLine[]) => new LoadClaimLinesSuccess(claimLines)
            )
          );
      },

      onError: (action: LoadClaimLines, error) => {
        
        return new LoadClaimLinesFail(error);
      }
    }
  );

  @Effect() create$ = this.dataPersistence.fetch(
    ClaimLinesActionTypes.CREATE_CLAIM_LINE,
    {
      run: (action: CreateClaimLine, state: ClaimLinesPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .create(action.payload)
          .pipe(
            map((claimLine: ClaimLine) => new CreateClaimLineSuccess(claimLine))
          );
      },

      onError: (action: CreateClaimLine, error) => {
        
        return new CreateClaimLineFail(error);
      }
    }
  );

  @Effect() edit$ = this.dataPersistence.fetch(
    ClaimLinesActionTypes.EDIT_CLAIM_LINE,
    {
      run: (action: EditClaimLine, state: ClaimLinesPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .edit(action.payload)
          .pipe(
            map((claimLine: ClaimLine) => new EditClaimLineSuccess(claimLine))
          );
      },

      onError: (action: EditClaimLine, error) => {
        
        return new EditClaimLineFail(error);
      }
    }
  );

  @Effect() delete$ = this.dataPersistence.fetch(
    ClaimLinesActionTypes.DELETE_CLAIM_LINE,
    {
      run: (action: DeleteClaimLine, state: ClaimLinesPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .delete(action.payload)
          .pipe(
            map(
              (claimLine: Partial<ClaimLineForm>) =>
                new DeleteClaimLineSuccess(claimLine)
            )
          );
      },

      onError: (action: DeleteClaimLine, error) => {
        
        return new DeleteClaimLineFail(error);
      }
    }
  );

  @Effect() assign$ = this.dataPersistence.fetch(
    ClaimLinesActionTypes.ASSIGN_CLAIM_LINE,
    {
      run: (action: AssignClaimLine, state: ClaimLinesPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .assign(action.payload)
          .pipe(
            map(
              (claimLine: Partial<ClaimLine>) =>
                new AssignClaimLineSuccess(claimLine)
            )
          );
      },

      onError: (action: AssignClaimLine, error) => {
        
        return new AssignClaimLineFail(error);
      }
    }
  );

  @Effect() verify$ = this.dataPersistence.fetch(
    ClaimLinesActionTypes.VERIFY_CLAIM_LINE,
    {
      run: (action: VerifyClaimLine, state: ClaimLinesPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .verify(action.payload)
          .pipe(
            map(
              (claimLine: Partial<ClaimLine>) =>
                new VerifyClaimLineSuccess(claimLine)
            )
          );
      },

      onError: (action: VerifyClaimLine, error) => {
        
        return new VerifyClaimLineFail(error);
      }
    }
  );

  @Effect() aprrove$ = this.dataPersistence.fetch(
    ClaimLinesActionTypes.APPROVE_CLAIM_LINE,
    {
      run: (action: ApproveClaimLine, state: ClaimLinesPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .approve(action.payload)
          .pipe(
            map(
              (claimLine: Partial<ClaimLine>) =>
                new ApproveClaimLineSuccess(claimLine)
            )
          );
      },

      onError: (action: ApproveClaimLine, error) => {
        
        return new ApproveClaimLineFail(error);
      }
    }
  );

  @Effect() return$ = this.dataPersistence.fetch(
    ClaimLinesActionTypes.RETURN_CLAIM_LINE,
    {
      run: (action: ReturnClaimLine, state: ClaimLinesPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .return(action.payload)
          .pipe(
            map(
              (claimLine: Partial<ClaimLine>) =>
                new ReturnClaimLineSuccess(claimLine)
            )
          );
      },

      onError: (action: ReturnClaimLine, error) => {
        
        return new ReturnClaimLineFail(error);
      }
    }
  );

  @Effect() reject$ = this.dataPersistence.fetch(
    ClaimLinesActionTypes.REJECT_CLAIM_LINE,
    {
      run: (action: RejectClaimLine, state: ClaimLinesPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .reject(action.payload)
          .pipe(
            map(
              (claimLine: Partial<ClaimLine>) =>
                new RejectClaimLineSuccess(claimLine)
            )
          );
      },

      onError: (action: RejectClaimLine, error) => {
        
        return new RejectClaimLineFail(error);
      }
    }
  );

  @Effect() submit$ = this.dataPersistence.fetch(
    ClaimLinesActionTypes.SUBMIT_CLAIM_LINE,
    {
      run: (action: SubmitClaimLine, state: ClaimLinesPartialState) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .submit(action.payload)
          .pipe(
            map(
              (claimLine: Partial<ClaimLine>) =>
                new SubmitClaimLineSuccess(claimLine)
            )
          );
      },

      onError: (action: SubmitClaimLine, error) => {
        
        return new SubmitClaimLineFail(error);
      }
    }
  );

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<ClaimLinesPartialState>,
    private service: ClaimLinesService
  ) {}
}
